import {Injectable, Inject, PLATFORM_ID} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";
import {environment} from "../../../../environments/environment";
import posthog from "posthog-js";

@Injectable({
    providedIn: "root"
})
export class AnalyticsService {
    private isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser && environment.posthog?.enabled) {
            posthog.init(environment.posthog.apiKey, {
                api_host: environment.posthog.apiHost,
                capture_pageview: false, // Page view tracking handled manually via routing
                person_profiles: 'always',
                capture_exceptions: true, // Auto-capture uncaught exceptions
                enable_recording_console_log: true, // Sync console logs inside session replays
                session_recording: {
                    maskAllInputs: true // Mask PII inputs for recordings
                },
                loaded: (ph) => {
                    ph.register({
                        platform: 'hireos' // Segment hireos events from standout
                    });
                }
            });
        }
    }

    capturePageView(): void {
        if (this.isBrowser && environment.posthog?.enabled) {
            posthog.capture("$pageview");
        }
    }

    captureEvent(eventName: string, properties?: Record<string, any>): void {
        if (this.isBrowser && environment.posthog?.enabled) {
            posthog.capture(eventName, properties);
        }
    }

    identifyUser(userId: string, email: string, additionalProps?: Record<string, any>): void {
        if (this.isBrowser && environment.posthog?.enabled) {
            posthog.identify(userId, {
                email,
                ...additionalProps
            });
        }
    }

    resetUser(): void {
        if (this.isBrowser && environment.posthog?.enabled) {
            posthog.reset();
        }
    }
}
